module.exports = __webpack_public_path__ + "img/useb-alchera-logo.35d2c0fa.svg";